// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminPanel.css - Стилі тільки для адмін-панелі */

.admin-panel-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.admin-panel-title {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 30px;
    text-align: center;
}

.admin-panel-subtitle {
    font-size: 1.5rem;
    color: #34495e;
    margin-bottom: 20px;
}

.admin-panel-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    font-size: 1.5rem;
    color: #7f8c8d;
}

.admin-panel-users-section {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 25px;
    margin-bottom: 30px;
}

.admin-panel-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.admin-panel-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
}

.admin-panel-table thead {
    background: #3498db;
    color: white;
}

.admin-panel-table th,
.admin-panel-table td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid #ecf0f1;
}

.admin-panel-table th {
    font-weight: 600;
    font-size: 0.95rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.admin-panel-table tbody tr {
    transition: background-color 0.2s ease;
}

.admin-panel-table tbody tr:hover {
    background-color: #f8f9fa;
}

.admin-panel-btn {
    background: #3498db;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: all 0.3s ease;
    margin-right: 8px;
}

.admin-panel-btn:hover {
    background: #2980b9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}

.admin-panel-btn:active {
    transform: translateY(0);
}

/* Адаптивність для планшетів */
@media screen and (max-width: 768px) {
    .admin-panel-container {
        padding: 15px;
    }

    .admin-panel-title {
        font-size: 1.5rem;
    }

    .admin-panel-subtitle {
        font-size: 1.2rem;
    }

    .admin-panel-users-section {
        padding: 15px;
    }

    .admin-panel-table {
        min-width: 500px;
    }

    .admin-panel-table th,
    .admin-panel-table td {
        padding: 10px;
        font-size: 0.9rem;
    }
}

/* Адаптивність для мобільних пристроїв */
@media screen and (max-width: 480px) {
    .admin-panel-container {
        padding: 10px;
    }

    .admin-panel-title {
        font-size: 1.3rem;
        margin-bottom: 20px;
    }

    .admin-panel-subtitle {
        font-size: 1.1rem;
        margin-bottom: 15px;
    }

    .admin-panel-users-section {
        padding: 10px;
        border-radius: 8px;
    }

    .admin-panel-table {
        min-width: 100%;
        font-size: 0.85rem;
    }

    .admin-panel-table thead {
        display: none;
    }

    .admin-panel-table,
    .admin-panel-table tbody,
    .admin-panel-table tr,
    .admin-panel-table td {
        display: block;
        width: 100%;
    }

    .admin-panel-table tr {
        margin-bottom: 15px;
        border: 1px solid #ecf0f1;
        border-radius: 8px;
        padding: 10px;
        background: #ffffff;
    }

    .admin-panel-table td {
        text-align: right;
        padding: 8px 10px;
        position: relative;
        border: none;
    }

    .admin-panel-table td:before {
        content: attr(data-label);
        position: absolute;
        left: 10px;
        font-weight: 600;
        color: #34495e;
        text-align: left;
    }

    .admin-panel-table td:last-child {
        text-align: center;
        padding-top: 15px;
    }

    .admin-panel-table td:last-child:before {
        display: none;
    }

    .admin-panel-btn {
        width: 100%;
        margin: 5px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/covfile/Admin.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,iHAAiH;AACrH;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA,yCAAyC;AACzC;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;;QAII,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,gBAAgB;QAChB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":["/* AdminPanel.css - Стилі тільки для адмін-панелі */\r\n\r\n.admin-panel-container {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\r\n}\r\n\r\n.admin-panel-title {\r\n    font-size: 2rem;\r\n    color: #2c3e50;\r\n    margin-bottom: 30px;\r\n    text-align: center;\r\n}\r\n\r\n.admin-panel-subtitle {\r\n    font-size: 1.5rem;\r\n    color: #34495e;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.admin-panel-loading {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 400px;\r\n    font-size: 1.5rem;\r\n    color: #7f8c8d;\r\n}\r\n\r\n.admin-panel-users-section {\r\n    background: #ffffff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    padding: 25px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.admin-panel-table-wrapper {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.admin-panel-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    min-width: 600px;\r\n}\r\n\r\n.admin-panel-table thead {\r\n    background: #3498db;\r\n    color: white;\r\n}\r\n\r\n.admin-panel-table th,\r\n.admin-panel-table td {\r\n    padding: 15px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #ecf0f1;\r\n}\r\n\r\n.admin-panel-table th {\r\n    font-weight: 600;\r\n    font-size: 0.95rem;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.admin-panel-table tbody tr {\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.admin-panel-table tbody tr:hover {\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.admin-panel-btn {\r\n    background: #3498db;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    transition: all 0.3s ease;\r\n    margin-right: 8px;\r\n}\r\n\r\n.admin-panel-btn:hover {\r\n    background: #2980b9;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);\r\n}\r\n\r\n.admin-panel-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n/* Адаптивність для планшетів */\r\n@media screen and (max-width: 768px) {\r\n    .admin-panel-container {\r\n        padding: 15px;\r\n    }\r\n\r\n    .admin-panel-title {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .admin-panel-subtitle {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .admin-panel-users-section {\r\n        padding: 15px;\r\n    }\r\n\r\n    .admin-panel-table {\r\n        min-width: 500px;\r\n    }\r\n\r\n    .admin-panel-table th,\r\n    .admin-panel-table td {\r\n        padding: 10px;\r\n        font-size: 0.9rem;\r\n    }\r\n}\r\n\r\n/* Адаптивність для мобільних пристроїв */\r\n@media screen and (max-width: 480px) {\r\n    .admin-panel-container {\r\n        padding: 10px;\r\n    }\r\n\r\n    .admin-panel-title {\r\n        font-size: 1.3rem;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .admin-panel-subtitle {\r\n        font-size: 1.1rem;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .admin-panel-users-section {\r\n        padding: 10px;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .admin-panel-table {\r\n        min-width: 100%;\r\n        font-size: 0.85rem;\r\n    }\r\n\r\n    .admin-panel-table thead {\r\n        display: none;\r\n    }\r\n\r\n    .admin-panel-table,\r\n    .admin-panel-table tbody,\r\n    .admin-panel-table tr,\r\n    .admin-panel-table td {\r\n        display: block;\r\n        width: 100%;\r\n    }\r\n\r\n    .admin-panel-table tr {\r\n        margin-bottom: 15px;\r\n        border: 1px solid #ecf0f1;\r\n        border-radius: 8px;\r\n        padding: 10px;\r\n        background: #ffffff;\r\n    }\r\n\r\n    .admin-panel-table td {\r\n        text-align: right;\r\n        padding: 8px 10px;\r\n        position: relative;\r\n        border: none;\r\n    }\r\n\r\n    .admin-panel-table td:before {\r\n        content: attr(data-label);\r\n        position: absolute;\r\n        left: 10px;\r\n        font-weight: 600;\r\n        color: #34495e;\r\n        text-align: left;\r\n    }\r\n\r\n    .admin-panel-table td:last-child {\r\n        text-align: center;\r\n        padding-top: 15px;\r\n    }\r\n\r\n    .admin-panel-table td:last-child:before {\r\n        display: none;\r\n    }\r\n\r\n    .admin-panel-btn {\r\n        width: 100%;\r\n        margin: 5px 0;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
